import React from 'react';
import { GiftIcon } from 'lucide-react';
import { Section } from './Section';
import { bonuses } from '../data/bonuses';
export function Bonuses() {
  return <Section background="paper" labelledBy="bonuses-heading" data-id="element-38" data-mp="plsky6ka14aa">
      <div className="text-center" data-id="element-39" data-mp="aua8ujujftw7">
        <p className="inline-flex items-center gap-2 rounded-full bg-sage-soft px-4 py-2 font-sans text-[11px] font-semibold uppercase leading-none tracking-[0.14em] text-sage" data-id="element-40" data-mp="at8uo6i86ra9">
          <GiftIcon className="h-3.5 w-3.5" strokeWidth={1.75} aria-hidden="true" data-id="element-41" data-mp="1t3pm30i84z9" />5 field tools
          included free
        </p>

        <h2 id="bonuses-heading" className="mx-auto mt-6 max-w-2xl font-serif text-[27px] font-semibold leading-[1.15] text-ink sm:text-3xl lg:text-[40px]" data-id="element-42" data-mp="3o1lgyw505tlk">
          Total value: $79 → free with Screen &amp; Adapt™
        </h2>

        <p className="mx-auto mt-5 max-w-2xl font-sans text-[16px] leading-[1.65] text-ink-soft" data-id="element-43" data-mp="1marwpvk2ko78">
          Each one removes a different point of friction: the preparation before class, the
          vocabulary during it, the speed of finding a page, the studio interview, and the message
          you send afterwards.
        </p>
      </div>

      <ul className="mt-12 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-44" data-mp="3r6i7l10s1lal">
        {bonuses.map(bonus => <li key={bonus.number} className="flex h-full flex-col overflow-hidden rounded-2xl border border-sage/15 bg-white shadow-card" data-id="element-45" data-mp="3n4wkkmuj3qmo">
            <div className="aspect-[4/3] w-full overflow-hidden bg-paper sm:aspect-square" data-id="element-46" data-mp="2ughbsi1zq4js">
              <img src={bonus.image} alt={`Cover of ${bonus.title}`} className="h-full w-full object-cover" loading="lazy" data-id="element-47" data-mp="38g8tasrpu32j" />
            </div>

            <div className="flex flex-1 flex-col p-6" data-id="element-48" data-mp="npi30a633srl">
              <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.14em] text-brass" data-id="element-49" data-mp="ns4ayaww0aac">
                Bonus {bonus.number}
              </p>
              <h3 className="mt-3 font-serif text-xl font-semibold leading-snug text-ink" data-id="element-50" data-mp="3chv41muq56l2">
                {bonus.title}
              </h3>
              <p className="mt-3 font-sans text-[14px] font-semibold" data-id="element-51" data-mp="3hk404s2w8ore">
                <span className="text-ink-muted line-through" data-id="element-52" data-mp="3lkw8zk7usrn5">{bonus.price}</span>
                <span className="ml-2 text-sage" data-id="element-53" data-mp="3qixpbxdwacux">→ Free</span>
              </p>
              <p className="mt-4 font-sans text-[15px] leading-[1.6] text-ink-soft" data-id="element-54" data-mp="2tsopmc0yr152">{bonus.body}</p>
            </div>
          </li>)}
      </ul>
    </Section>;
}